module.exports = require("url-polyfill");